"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siteToastSelector = exports.sitesListOptionsSelector = exports.createSiteErrorMessage = exports.createSitesSuccessMessage = exports.isCreatingSiteSelector = exports.isAddSiteModalOpenSelector = exports.isSiteListLoadingSelector = exports.siteListSelector = void 0;
const reselect_1 = require("reselect");
const siteListSelector = (state) => {
    return state.sites.siteList;
};
exports.siteListSelector = siteListSelector;
const isSiteListLoadingSelector = (state) => {
    return state.sites.isSiteListLoading;
};
exports.isSiteListLoadingSelector = isSiteListLoadingSelector;
const isAddSiteModalOpenSelector = (state) => {
    return state.sites.isAddSiteModalOpen;
};
exports.isAddSiteModalOpenSelector = isAddSiteModalOpenSelector;
const isCreatingSiteSelector = (state) => {
    return state.sites.isCreatingSite;
};
exports.isCreatingSiteSelector = isCreatingSiteSelector;
const createSitesSuccessMessage = (state) => {
    return state.sites.createSitesSuccessMessage;
};
exports.createSitesSuccessMessage = createSitesSuccessMessage;
const createSiteErrorMessage = (state) => {
    return state.sites.createSiteErrorMessage;
};
exports.createSiteErrorMessage = createSiteErrorMessage;
exports.sitesListOptionsSelector = (0, reselect_1.createSelector)(exports.siteListSelector, (sites) => {
    return sites.map((site) => {
        return {
            label: site.name,
            value: site.id,
        };
    });
});
const siteToastSelector = (state) => {
    return state.sites.siteToast;
};
exports.siteToastSelector = siteToastSelector;
